export default __webpack_public_path__ + "static/media/ll.63ffeb9e.jpg";